import Bloc from './Bloc.js';
import Types from './Types.js';

export default class OvergrowthBonus extends Bloc {

	constructor (src, ctx) {

		super("overgrowthbonus", src, ctx);
		this.f = (src, ins) => [Math.round(src.master.player.computeOvergrowthCardBonus(ins[0], src))];
		this.types = [Types.int];
	}
}
